import React from 'react'
import { Route } from 'react-router-dom'
import Main from './Main'
import MissingInformation from './MissingInformation'
import Layout from './Layout/index'
import TOC from './TOC'
import RequiredInformation from './RequiredInformation'
import ManualVerification from './ManualVerification'
import Finish from './Finish'

// prettier-ignore
export default (
  <Route>
    <Route path='new-kyc/:id' element={<React.Suspense><Layout /></React.Suspense>}>
      <Route index element={<React.Suspense><Main /></React.Suspense>} />
      <Route path='required-information' element={<React.Suspense><RequiredInformation /></React.Suspense>} />
      {TOC}
      <Route path='manual-verification' element={<React.Suspense><ManualVerification /></React.Suspense>} />
      <Route path='missing-information' element={<React.Suspense><MissingInformation /></React.Suspense>} />
      <Route path='finish' element={<React.Suspense><Finish /></React.Suspense>} />
    </Route>
  </Route>
)
